import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  access_token: "",
  isLogin: false,
  user: null,
  mode: "light",
  isOpen: false,
  fcmToken: "abc",
  isSidebarCollapsed: false,
};

const authSlice = createSlice({
  name: "authSlice",
  initialState,
  reducers: {
    saveLoginUserData(state, action) {
      state.user = action.payload?.data?.user;
      state.isLogin = true;
      state.access_token = action.payload?.data?.token;
    },
    updateUser(state, action) {
      state.user = action.payload;
    },
    signOutRequest(state) {
      state.access_token = "";
      state.isLogin = false;
      state.user = null;
    },
    ToggleDrawer(state, action) {
      state.isOpen = action.payload;
    },
    updateToken(state, action) {
      state.access_token = action.payload;
    },
    setSideBarCollapsed(state, action) {
      state.isSidebarCollapsed = action.payload;
    },
  },
});

export const {
  saveLoginUserData,
  signOutRequest,
  ToggleDrawer,
  updateUser,
  updateToken,
  setSideBarCollapsed,
} = authSlice.actions;

export default authSlice.reducer;
